
































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { AloPanier } from '@/models/alo/AloPanier'
import { QtyItem } from '@/models/ui/QtyItem'
import { AloForfait, getDefaultAloForfait } from '@/models/alo/AloForfait'
import { getImageUrl } from '@/utils/images'

@Component({
  name: 'CartItem',
  props: {
    item:{
      type:Object,
      required:true
    },
    readOnly:{
      type:Boolean,
      default:false
    }
  }
})
export default class CartItem extends Vue {
  item!:QtyItem<AloForfait>     
  readOnly!:Boolean
    

  get getImageUrl(){
    return getImageUrl
  }

  get activityDic(){
    return this.$store.myGetters.activityDic
  }
  
  get canAdd(){
    return this.item.item.fftLimiteAchat == null || this.item.item.fftLimiteAchat > this.item.qty
  }

  udpateQty(qty:number){
    if(this.item.item.fftLimiteAchat == null || this.item.item.fftLimiteAchat > qty || this.item.qty > qty) {
      this.$emit('udpateQty',qty)    
    }
  }  

  created(){
    this.$store.myActions.ADM_ACTIVITY_ENSURE()
  }

}
